import React from 'react';
import { useLocation } from 'react-router';

const ScrollToTop = ({ children, ignorePaths = [] }) => {
	const location = useLocation();

	React.useEffect(() => {
		if (!ignorePaths.includes(location.pathname)) window.scrollTo(0, 0);
	}, [location.pathname, ignorePaths]);

	return <>{children}</>;
};

export default ScrollToTop;
